/**
 * Gmail renders inline images in the `text/plain` alternative as bracketed
 * placeholders like `[image: foo.png]` or `[cid:<uuid>]`. We already show
 * the image itself via the attachments block, so leaving these markers in
 * the body/preview text produces confusing duplicate references.
 *
 * Patterns covered:
 *   `[image: whatever.png]` · `[изображение: …]` · `[cid:…]` · `<image-0001>`
 *
 * Shared by message-bubble (full body) and conversation-list-item (inbox
 * snippet) so both strip the exact same markers — a marker added to one and
 * not the other would make the list preview disagree with the rendered body.
 */
export const INLINE_ATTACHMENT_MARKER_RE = /\[\s*(?:image|изображение|img|cid|inline|attachment|файл|картинка)[:\s][^\]\n]{0,300}\]/gi;
export const CID_ANGLE_RE = /<(?:cid:)?[\w.+-]+@[\w.-]+>/gi;
/** Strips the markers, leaving whitespace collapse to the caller. */
export function stripInlineAttachmentMarkers(text) {
    return text.replace(INLINE_ATTACHMENT_MARKER_RE, '').replace(CID_ANGLE_RE, '');
}
//# sourceMappingURL=strip-inline-attachment-markers.js.map